import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	hasAccess: {
		id: 'servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-list.principal-item.has-access',
		defaultMessage: 'Has access',
		description:
			'Text in the request type permission list indicating the user/group can access the request type.',
	},
	noAccess: {
		id: 'servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-list.principal-item.no-access',
		defaultMessage: 'No access',
		description:
			'Text in the request type permission list indicating the user/group cannot access the request type.',
	},
	remove: {
		id: 'servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-list.principal-item.remove',
		defaultMessage: 'Remove',
		description:
			'Text for the button in the request type permission list allowing the user to remove the user/group.',
	},
	customerOrganization: {
		id: 'servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-list.principal-item.customer-organization',
		defaultMessage: 'Customer organization',
		description: 'Byline for customer organization',
	},
	group: {
		id: 'servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-list.principal-item.group',
		defaultMessage: 'Group',
		description: 'Byline for user group',
	},
});
